module.exports = __webpack_public_path__ + "img/01.9d5de0aa.jpg";